import { render, staticRenderFns } from "./bankAccountList.vue?vue&type=template&id=1fcd5857"
import script from "./bankAccountList.vue?vue&type=script&lang=ts"
export * from "./bankAccountList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports